module.exports = __webpack_public_path__ + "static/pinkfloral2-1cf8c5157ae5e8ff24101207e2d56448.png";